(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landing-nps"]) return;
  try {
    
  window.addEventListener('klaviyoForms', function(e){
    //console.log(e)
    e.detail.type == "stepSubmit" && window.scrollTo({top: 0, behavior: "smooth"});
  })

  } catch(e) { console.error(e); }
})();
})();
